/** @jsx jsx */
import { jsx } from "theme-ui"
import Svg from "./base"

const Icon = props => (
  <Svg width="971" height="71" {...props}>
    <path fill="#B92A2E" d="M0 44V31h966a5 5 0 015 5v3a5 5 0 01-5 5H0z"></path>
    <path fill="#C97740" d="M0 22v-8h866a4 4 0 010 8H0z"></path>
    <path fill="#DD5A3D" d="M0 71V54h879a5 5 0 015 5v7a5 5 0 01-5 5H0z"></path>
    <path fill="#E8CD4B" d="M0 4V0h683a2 2 0 110 4H0z"></path>
  </Svg>
)

export default Icon
